import Input from "./Input";
import Phone from "./Phone";

const Composition = Object.assign(Input, {
  Phone,
});

export default Composition;
